import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Copy, UnorderedList } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { stripMarkdownHeading } from '../../../utils/markdown';
import themeStyles from './styles/Details.styles';
var HighlightWrapper = themeStyles.apply(Box, 'HighlightWrapper');
var HightlightsHeading = themeStyles.apply(Copy, 'HightlightsHeading');
var List = themeStyles.apply(UnorderedList, 'List');
var Highlights = function (_a) {
    var modelHighlights = _a.modelHighlights;
    var t = useTranslation().t;
    var highlightItems = modelHighlights.split('\r\n');
    return (React.createElement(HighlightWrapper, null,
        React.createElement(HightlightsHeading, null, t('Shared.Common.highlightsLabel')),
        React.createElement(List, { "data-testid": "cy-model-highlights" }, highlightItems === null || highlightItems === void 0 ? void 0 : highlightItems.map(function (item) { return (React.createElement("li", { key: item },
            React.createElement(Copy, null, compiler(stripMarkdownHeading(item))))); }))));
};
export default Highlights;
